import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

export interface AppCardDividerProps extends HTMLAttributes<HTMLHRElement> {}

export const AppCardDivider: FC<AppCardDividerProps> = ({ className, ...props }) => (
    <hr className={classNames('app-card__divider', className)} {...props} />
);
